<script>
import MfLoading from "@/desktop/views/mf/components/MfLoading";
import mf_Mixin from "@/desktop/views/mf/mixin";
import { mapGetters } from "vuex";
import Sincerely from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/Sincerely.vue";
import EditServicePopup from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/EditServicePopup.vue";
import EmailPopup from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/SendEmailPopup.vue";
import OperateContractItemTD from "@/desktop/views/mf/components/OperateContractItem_TD.vue";
import FixedBottom from "@/desktop/views/mf/components/fixedBotton";

export default {
  props: ["hasQualification"],
  mixins: [mf_Mixin],
  components: {
    Sincerely,
    EditServicePopup,
    FixedBottom,
    EmailPopup,
    MfLoading,
    OperateContractItemTD,
  },
  data() {
    return {
      serviceInfo: {
        name: "",
        mktDeptName: "",
        depPhone: [],
        mobile: "",
        mail: "",
      },
      editServicePopupOpen: false,
      emailPopupOpen: false,
      emailSending: false,
      reportList: [],
      coverSelect: "0",
      sincerelySelect: "2",
      sincerely__otherTitle: "",
      sincerely__insuredTitle: "",
      sincerely__insurerTitle: "",
      coverImgMap: {
        cover1: require("@/desktop/views/mf/assets/cover/1.png"),
        cover2: require("@/desktop/views/mf/assets/cover/2.png"),
        cover3: require("@/desktop/views/mf/assets/cover/3.png"),
        cover4: require("@/desktop/views/mf/assets/cover/4.png"),
        cover5: require("@/desktop/views/mf/assets/cover/5.png"),
        cover6: require("@/desktop/views/mf/assets/cover/6.png"),
      },
      proposal: {},
      is_print_selected: true,
      proposalListScope: [],
      is_ready: false,
      isLoading: true,
      isDisabledMergeBenefitPrint: false,
      isDisabledSpilloverPointsPrint: false,
      printMethod: "1",
      serviceInfoScope: {},
      isValidate: true,
    };
  },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo", "MfViewing"]),
    coverList() {
      return this.$paragrpno.cover_type.map((cover, index) => {
        return {
          ...cover,
          name: index == 0 ? "不列印封面" : `封面${index}`,
          imgURL: this.coverImgMap[cover.paradetlno],
        };
      });
    },
    is_selected() {
      return this.reportList.some((item) => {
        return item.is_checked;
      });
    },
    printMethodComputed: {
      get() {
        return this.printMethod;
      },
      set(value) {
        this.printMethod = value;

        if (value === "1") {
          this.selectAll(true);
        }
        if (value === "2") {
          this.$mfNotice(
            "",
            () => {},
            null,
            false,
            "確定",
            "系統預設列印一式兩份，請同仁進行新契約招攬或補全文件，務必提供建議書予保戶，並請保戶詳閱後留存。",
          );
        }
      },
    },
  },
  async created() {
    this.reportList = this.$paragrpno.chapter
      .map((item) => {
        item.is_checked = true;
        return item;
      })
      .filter((item) => item.paraval !== "8" && item.paraval !== "2");
    let res = await this.$mfAPI.MFA0_1000__queryProposalDetailList({
      agent_id: this.$store.state.userInfo.id,
      insured_id: "",
      prod_idx: this.MfViewing.saveData.prod_idx,
    });
    this.proposal = res.proposal[0];
    this.isLoading = false;
    this.proposalListScope = this.proposal.mc_prod_list;
    // 整份建議書沒有 CWP_LEVEL=2，不顯示外溢點數回饋說明
    if (!this.hasTreePointProd()) {
      this.reportList = this.reportList.filter(
        (item) => item.paraval !== "10",
      );
    }
    //查找登入者資訊(MF)
    let result = await this.$mfAPI.MVI0_0100_query({
      agnt_id: this.$store.state.userInfo.id,
    });
    this.serviceInfo = {
      ...result,
    };
    setTimeout(() => {
      this.registerHanlink();
    }, 100);
  },
  methods: {
    sendEmailHandler($event) {
      this.emailPopupOpen = false;
      this.emailSending = true;
      this.printProposal(null, "send", $event);
    },
    selectAll(selectType) {
      this.reportList.forEach((item) => {
        item.is_checked = this.isReportSelectable(item, selectType);
      });
    },
    async printProposal(chapter, mode = "print", mailForm) {
      let toPrintList = this.proposalListScope.filter((item) => {
        return item.is_checked;
      });
      //檢核日額通算
      /*
      let checkDailyCalculateRes = await this.checkDailyCalculate({
        insured_age: this.proposal.insured_age,
        mc_prod_list: toPrintList
      });
      if (!checkDailyCalculateRes) return;
      */
      //mode為開啟或寄出：print/send
      let chapter_tp_list = [];
      if (chapter) {
        chapter_tp_list = [chapter];
      } else {
        this.reportList.forEach((item) => {
          if (item.is_checked) {
            chapter_tp_list.push(item.paraval);
          }
        });
      }

      let selectedCover = this.coverList.find(
        (item) => item.paraval == this.coverSelect,
      );
      let toName = "";
      let toSalutation = "";
      switch (this.sincerelySelect) {
        case "1":
          toName = this.MfViewing.insurer.insured_name;
          toSalutation = this.sincerely__insurerTitle;
          break;
        case "2":
          toName = this.MfViewing.insured.insured_name;
          toSalutation = this.sincerely__insuredTitle;
          break;
        case "3":
          toName = this.sincerely__otherTitle;
          break;
      }

      let mc_idx_selected_list = this.proposal.mc_prod_list.map((mc) => {
        if (mc.is_checked) {
          return mc.mc_idx;
        }
      });
      let printObj = {
        prod_idx: this.MfViewing.saveData.prod_idx,
        agent_id: this.$store.state.userInfo.id,
        insured_id: this.MfViewing.saveData.insured_id,
        chapter_tp_list: chapter_tp_list,
        channel_type: this.$store.getters.UserChannelType,
        coverInfoMap: {
          cover_type: chapter ? "0" : selectedCover.paraval,
          cover_type_nm: selectedCover.paradetlno,
          name: toName,
          salutation: toSalutation,
          agent_name: this.serviceInfo.agnt_name,
          corp: this.serviceInfo.cevnm || "",
          corp_tel:
            this.serviceInfo.corp_tel_area +
            (!this.serviceInfo.corp_tel_area
              ? ""
              : "-" + this.serviceInfo.corp_tel),
          mobile: this.serviceInfo.mobile,
          email: this.serviceInfo.email,
          agent_name2: this.serviceInfoScope.agnt_name || "",
          corp2: this.serviceInfoScope.cevnm || "",
          corp_tel2:
            (this.serviceInfoScope.corp_tel_area || "") +
            (!this.serviceInfoScope.corp_tel_Number
              ? ""
              : "-" + this.serviceInfoScope.corp_tel_Number) +
            (!this.serviceInfoScope.crop_tel_Ext
              ? ""
              : "#" + this.serviceInfoScope.crop_tel_Ext),
          mobile2: this.serviceInfoScope.mobile,
          email2: this.serviceInfoScope.email,
        },
        isINV: false,
        printMethod: this.printMethodComputed,
        printScopeMap: {
          separate_year: "999", //"開始列印至"的年度
          interval_year: "1", //間隔幾年
        },
        mc_idx_selected_list: mc_idx_selected_list,
        hasQualification: this.hasQualification,
      };
      if (mode == "print") {
        var newWindow = window.open("");
        newWindow.document.write(`
          <html style="height: 100%;">
          <head>
          <meta name="viewport" content="width=device-width, minimum-scale=0.1">
          <title>PDF LOADING...</title>
          </head>
          <body style="margin: 0px; background: #0e0e0e; height: 100%">
          <div><img style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;" src="/crm/assets/common/mv-pdf-loader.gif"></div>
          </body></html>
      `);
        if (
          window.location.href.indexOf("localhost") !== -1 ||
          window.location.href.indexOf(process.env.VUE_APP_DEV_IP) !== -1
        ) {
          this.$mfAPI.MFR0_2000__printReport(printObj).then(function (res) {
            let file = new Blob([res.data], { type: "application/pdf" });
            let fileURL = URL.createObjectURL(file);
            newWindow.location = fileURL;
            setTimeout(() => {
              newWindow.document.title = "建議書章節預覽";
            }, 100);
          });
        } else {
          this.$mfAPI
            .MFR0_2000__printReportToFile(printObj)
            .then((response) => {
              let { header, body } = response.data;
              if (parseInt(header.status) < 0) {
                if (body && body.spillover_point_error === "1") { 
                  newWindow.close();
                  this.$toast.info({ title: header.message }); 
                } else {
                  this.$toast.info({ title: `執行失敗` });
                }
                return Promise.reject(header.message);
              } else if(this.$store.getters.IsBFF_MF){
                let targetURL = `${window.location.origin}/mid-mxf0-crm-ui/api/v1/MFR00100/downloadReport?fileNo=${body.fileNo}`;
                newWindow.location = targetURL;
              } else {
                let targetURL = `${this.$store.getters.MfPdfBaseURL}/MFR0_0100/downloadReport?fileNo=${body.fileNo}`;
                newWindow.location = targetURL;
              }
            });
        }
      } else if ((mode = "send" && mailForm)) {
        //寄出email
        this.$mfAPI
          .MFR0_2000__mailReport({
            ...printObj,
            //以下為send專屬
            receiver: mailForm.TO, //收件人信箱
            receiverName: "", //收件人
            subject: mailForm.Title, //信件標題
            receivercc: mailForm.CC, //副本信箱
            sender:
              mailForm.FROM +
              (this.$store.getters.IsBankUser
                ? "@cathaybk.com.tw"
                : "@cathaylife.com.tw"), //寄件人信箱
            isINV: false,
            channel_type: this.$store.getters.UserChannelType,
          })
          .then(({ data }) => {
            this.emailSending = false;
            if (parseInt(data.header.status) < 0) {
              // this.$toast.info({ title: data.header.message });
              if (data.body && data.body.spillover_point_error === "1") { 
                this.$toast.info({ title: data.header.message }); 
              } else {
                this.$toast.info({ title: "執行失敗" });
              }
            } else {
              this.$toast.info({ title: `發送成功!` });
            }
          })
          .catch((error) => {
            this.emailSending = false;
            // this.$toast.info({ title: `${error}` });
            this.$toast.info({ title: "執行失敗" });
          });
      }
    },
    handleUpdate(mc_prod_list) {
      this.proposalListScope = mc_prod_list;
      this.is_print_selected = false;
      this.proposalListScope.forEach((mc) => {
        if (mc.is_checked) {
          this.is_print_selected = true;
        }
      });
      this.checkMergeBenefit();
      this.checkSpilloverPointsReport();
    },
    updateReady() {
      this.is_ready = true;
      this.checkMergeBenefit();
      this.checkSpilloverPointsReport();
    },
    checkMergeBenefit() {
      let checked_count = 0;
      this.proposalListScope.forEach((mc) => {
        if (mc.is_checked) {
          checked_count++;
        }
      });
      let isDisabled = checked_count < 2;
      this.isDisabledMergeBenefitPrint = isDisabled;
    },
    // 檢核外溢點數回饋說明是否可勾選
    checkSpilloverPointsReport() {
      const isDisabled =
        !this.hasSelectedTreePointProd() ||
        !this.isAdulthood();

      this.isDisabledSpilloverPointsPrint = isDisabled;

      this.reportList.forEach((item) => {
        if (item.paraval === "10" && isDisabled) {
          item.is_checked = false;
        }
      });
    },
    // 判斷單一契約的主約或附約是否包含 CWP_LEVEL=2
    isTreePointContract(mc) {
      if (mc.cwp_level === "2") {
        return true;
      }

      const sc_prod_list = mc.sc_prod_list || [];
      return sc_prod_list.some((sc) => sc.cwp_level === "2");
    },
    // 整份建議書是否包含 CWP_LEVEL=2
    hasTreePointProd() {
      return this.proposalListScope.some((mc) => {
        return this.isTreePointContract(mc);
      });
    },
    // 目前勾選的契約是否包含 CWP_LEVEL=2
    hasSelectedTreePointProd() {
      return this.proposalListScope.some((mc) => {
        return mc.is_checked && this.isTreePointContract(mc);
      });
    },
    // 被保險人是否已滿18歲
    isAdulthood() {
      return (
        !isNaN(Number(this.proposal.insured_age)) &&
        Number(this.proposal.insured_age) >= 18
      );
    },
    isReportSelectable(report, selectType = true) {
      if (!selectType) return false;

      if (report.paraval === "10" && this.isDisabledSpilloverPointsPrint) {
        return false;
      }
      return true;
    },
    async checkValidate() {
      this.isValidate = await this.$validator.validateAll();
    },
  },
  directives: {
    mfOnlyNumber: {
      bind: function (el, binding) {
        el.handler = function () {
          if (binding.value.targetObj && binding.value.targetKey) {
            binding.value.targetObj[binding.value.targetKey] = el.value.replace(
              /\D+/,
              "",
            );
          }
        };
        el.addEventListener("input", el.handler);
      },
      unbind: function (el) {
        el.removeEventListener("input", el.handler);
      },
    },
  },
};
</script>

<template>
  <main class="printProposal container-fluid mf_container pb_50 mb_50">
    <div v-show="is_ready">
      <h4 class="text-green mt_22">保險規劃建議書</h4>
      <div class="printProposal__step mt_13">步驟1/3:選擇要列印的建議商品</div>
      <OperateContractItemTD
        @isReady="updateReady"
        v-if="!isLoading"
        selectedMode="checkbox"
        :contractData="proposal"
        @updateMCProdList="handleUpdate"
      ></OperateContractItemTD>
      <div class="printProposal__step mt_13">步驟2/3:選擇報表</div>

      <!-- 選擇列印方式 -->
      <h5 class="text-green mt_18">選擇列印方式</h5>
      <div class="mt_15 text-red fz_18 font-weight-bold">
        系統預設列印一式兩份，請同仁進行新契約招攬或補全文件，務必提供建議書予保戶，並請保戶詳閱後留存。
      </div>
      <div class="d-flex align-items-center mt_10">
        <div class="d-flex align-items-center radio radio-inline mr_25">
          <input
            v-model="printMethodComputed"
            type="radio"
            id="B_1"
            value="1"
          />
          <label for="B_1"></label>
          列印一式兩份(公司及保戶留存)
        </div>
        <div class="d-flex align-items-center radio radio-inline">
          <input
            v-model="printMethodComputed"
            type="radio"
            id="B_3"
            value="2"
          />
          <label for="B_3"></label>
          選擇所有報表
        </div>
      </div>

      <!-- 可選報表 -->
      <div class="text-green mt_18">
        <strong class="font-20">可選報表</strong>
        <button
          type="button"
          class="btn btn-default btn-sm baseLine"
          :class="{ invisible: printMethod === '1' }"
          @click="selectAll(true)"
          v-show="!is_selected"
        >
          選取所有報表
        </button>
        <button
          type="button"
          class="btn btn-default btn-sm baseLine"
          :class="{ invisible: printMethod === '1' }"
          @click="selectAll(false)"
          v-show="is_selected"
        >
          清空所有報表
        </button>
      </div>

      <div class="printProposal__reportList">
        <div
          class="printProposal__reportList__item"
          v-for="report in reportList"
          :key="report.name"
        >
          <div class="printProposal__reportList__item__main">
            <div class="checkbox checkbox-inline mr_5">
              <input
                type="checkbox"
                :id="`report__${report.paraval}`"
                v-model="report.is_checked"
                class="mr_5"
                :disabled="printMethod === '1'||
                          (report.paraval == '10' && isDisabledSpilloverPointsPrint)
                "
              />
              <label :for="`report__${report.paraval}`"></label>
            </div>
            <div>{{ report.paradetlno }}</div>
            <a
              v-if="!(report.paraval == '8' && isDisabledMergeBenefitPrint) &&
                    !(report.paraval == '10' && isDisabledSpilloverPointsPrint)
              "
              href="###"
              class="ml_10 text-green"
              @click="printProposal(report.paraval)"
              >預覽</a
            >
            <div
              v-if="
                report.paraval == '10' &&
                isDisabledSpilloverPointsPrint
              "
              class="printProposal__reportList__item__spilloverPointsRmk"
            >
              僅限符合外溢發點商品且被保險人實際年齡須達18歲(含)。
            </div>
          </div>
        </div>
      </div>
      <div class="printProposal__step mt_13">步驟3/3:設定封面資訊</div>
      <!-- 封面樣式 -->
      <h5 class="text-green mt_18">封面樣式</h5>
      <div class="printProposal__cover row">
        <div
          :class="{ 'order-12': index == 0 }"
          v-for="(cover, index) in coverList"
          :key="cover.paraval"
          style="width: 14%; padding: 0.3%"
        >
          <div class="printProposal__cover mt_10">
            <div class="radio radio-inline mr_7">
              <input
                type="radio"
                name="printProposal__cover"
                :value="cover.paraval"
                :id="`printProposal__cover__${cover.paraval}`"
                v-model="coverSelect"
              />
              <label :for="`printProposal__cover__${cover.paraval}`"></label>
            </div>
            <div class="printProposal__cover__info">
              <div>{{ cover.name }}</div>
            </div>
          </div>
          <div class="printProposal__cover__info__pic" v-if="index != 0">
            <img :src="cover.imgURL" alt="" />
          </div>
        </div>
      </div>
      <!-- 謹致 -->
      <Sincerely
        :sincerelySelect.sync="sincerelySelect"
        :sincerely__otherTitle.sync="sincerely__otherTitle"
        :sincerely__insuredTitle.sync="sincerely__insuredTitle"
        :sincerely__insurerTitle.sync="sincerely__insurerTitle"
      />
      <!-- 服務人員資訊 -->
      <div class="d-flex align-items-center mt_15">
        <h5 class="text-green mr_5">服務人員資訊</h5>
        <a class="btn btn-default mx-2" @click="editServicePopupOpen = true">
          修改
        </a>
      </div>
      <div class="printProposal__serviceInfo mt_15">
        <div class="printProposal__serviceInfo__item mb_5">
          <strong>保險顧問</strong>
          <div>{{ serviceInfo.agnt_name }}</div>
        </div>
        <div class="printProposal__serviceInfo__item mb_5">
          <strong>服務單位</strong>
          <div>{{ serviceInfo.cevnm }}</div>
        </div>
        <div class="printProposal__serviceInfo__item mb_5">
          <strong>公司電話</strong>
          <div>({{ serviceInfo.corp_tel_area }}){{ serviceInfo.corp_tel }}</div>
        </div>
        <div class="printProposal__serviceInfo__item mb_5">
          <strong>行動電話</strong>
          <div>{{ serviceInfo.mobile }}</div>
        </div>
        <div class="printProposal__serviceInfo__item mb_5">
          <strong>MAIL</strong>
          <div>{{ serviceInfo.email }}</div>
        </div>
      </div>
      <div class="d-flex align-items-center mt_15">
        <h5 class="text-green mr_5">服務人員資訊2</h5>
      </div>
      <div class="d-flex align-items-center mt_15">
        <section class="editServiceForm search pt_0">
          <label class="editServiceForm__inputItem mb_10">
            <span>保險顧問</span>
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 250px"
              v-model.trim="serviceInfoScope.agnt_name"
              alt="ch"
              maxlength="13"
              placeholder="最多輸入13個中文字"
              @change="checkValidate"
            />
          </label>
          <label class="editServiceForm__inputItem mb_10">
            <span>服務單位</span>
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 250px"
              v-model.trim="serviceInfoScope.cevnm"
              maxlength="20"
              placeholder="最多輸入20個中文字"
              @change="checkValidate"
            />
          </label>
          <label class="editServiceForm__inputItem mb_10">
            <span>公司電話</span>
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 40px"
              v-model.trim="serviceInfoScope.corp_tel_area"
              maxlength="4"
              v-mfOnlyNumber="{
                targetObj: serviceInfoScope,
                targetKey: 'corp_tel_area',
              }"
              @input="
                serviceInfoScope.corp_tel_area =
                  serviceInfoScope.corp_tel_area.replace(/[^\d]/g, '')
              "
              @change="checkValidate"
            />
            <strong>-</strong>
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 102px"
              v-model.trim="serviceInfoScope.corp_tel_Number"
              maxlength="15"
              v-mfOnlyNumber="{
                targetObj: serviceInfoScope,
                targetKey: 'corp_tel_Number',
              }"
              @input="
                serviceInfoScope.corp_tel_Number =
                  serviceInfoScope.corp_tel_Number.replace(/[^\d]/g, '')
              "
              @change="checkValidate"
            />
            <strong>#</strong>
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 68px"
              v-model.trim="serviceInfoScope.crop_tel_Ext"
              maxlength="10"
              v-mfOnlyNumber="{
                targetObj: serviceInfoScope,
                targetKey: 'crop_tel_Ext',
              }"
              @input="
                serviceInfoScope.crop_tel_Ext =
                  serviceInfoScope.crop_tel_Ext.replace(/[^\d]/g, '')
              "
              @change="checkValidate"
            />
          </label>
          <label class="editServiceForm__inputItem mb_12">
            <span>行動電話</span>
            <div class="position-relative">
              <input
                type="text"
                class="form-control form-control-inline"
                style="width: 250px"
                v-model.trim="serviceInfoScope.mobile"
                data-vv-name="phone"
                v-validate="'phone'"
                :class="{ 'is-invalid': errors.has(`phone`) }"
                maxlength="10"
                v-mfOnlyNumber="{
                  targetObj: serviceInfoScope,
                  targetKey: 'mobile',
                }"
                @change="checkValidate"
              />
              <span class="waring-text">
                {{ errors.first(`phone`) ? "行動電話格式有誤" : "" }}
              </span>
            </div>
          </label>
          <label class="editServiceForm__inputItem mb_10">
            <span>MAIL</span>
            <div class="position-relative">
              <input
                type="text"
                class="form-control form-control-inline"
                style="width: 250px"
                v-model.trim="serviceInfoScope.email"
                data-vv-name="email"
                v-validate="'email'"
                :class="{ 'is-invalid': errors.has(`email`) }"
                @change="checkValidate"
              />
              <span class="waring-text">
                {{ errors.first(`email`) ? "MAIL格式有誤" : "" }}
              </span>
            </div>
          </label>
        </section>
      </div>
      <EditServicePopup
        :open="editServicePopupOpen"
        @close="editServicePopupOpen = false"
        :serviceInfo.sync="serviceInfo"
      />
      <EmailPopup
        :open="emailPopupOpen"
        @close="emailPopupOpen = false"
        @send="sendEmailHandler($event)"
      />
      <FixedBottom>
        <template slot="@function">
          <div class="d-flex justify-content-end mr_15">
            <router-link
              class="btn btn-default px_5 mr_10"
              to="/mf/query/queryDetail"
              >查詢其他建議書</router-link
            >
            <button
              class="btn btn-primary px_5 mr_10"
              type="button"
              @click="printProposal()"
              :disabled="!is_selected || !is_print_selected || !isValidate"
            >
              開啟PDF
            </button>
            <button
              class="btn btn-primary px_5 mr_10"
              type="button"
              @click="emailPopupOpen = true"
              :disabled="
                !is_selected ||
                $store.getters.BuTest ||
                !is_print_selected ||
                !isValidate
              "
              v-show="!this.$store.getters.IsBankUser"
            >
              發送EMAIL
            </button>
          </div>
        </template>
      </FixedBottom>
      <!-- email發送中 -->
      <MfLoading :open="emailSending" content="EMAIL發送中..." />
    </div>
    <MfLoading :open="!is_ready" content="資料讀取中..." />
  </main>
</template>

<style lang="scss" scoped>
.font-20 {
  font-size: 20px;
}
.mb-30 {
  margin-bottom: 30px;
}
.baseLine {
  vertical-align: baseline !important;
}
.printProposal {
  color: #323a45;
  @media (min-width: 1025px) {
    width: 100%;
    max-width: 1280px;
  }
  &__step {
    font-size: 24px;
    color: #323a45;
    font-weight: 700;
  }
  &__reportList {
    padding: 20px 0;
    &__item {
      border-bottom: solid 1px #e0e1e3;
      display: flex;
      flex-direction: column;
      padding: 12px 0 18px;
      &__main {
        display: flex;
        align-items: center;
      }
      &__sub {
        display: flex;
        align-items: center;
        font-size: 14px;
        padding-left: 42px;
      }
      &__spilloverPointsRmk {
        color: gray;
      }
    }
  }
  &__cover {
    width: 100%;
    display: flex;
    align-items: flex-start;
    line-height: 40px;
    &__info {
      width: 100%;
      padding-right: 40px;
      &__pic {
        width: 100%;
        border: solid 1px #707070;
        img {
          width: 100%;
          display: flex;
        }
      }
    }
  }
  &__serviceInfo {
    &__item {
      display: flex;
      align-items: center;
      strong {
        display: inline-block;
        margin-right: 10px;
        width: 64px;
        line-height: 1.38;
      }
    }
  }
  .emailSending {
    height: 172px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
  }
}

.importMobile {
  color: #323a45;
  @media (min-width: 1025px) {
    width: 100%;
    max-width: 1280px;
  }
  &__proposalList {
    padding: 20px 0;
    &__item {
      display: flex;
      align-items: flex-start;
      border-bottom: solid 1px #e0e1e3;
    }
    .checkbox input + label:before {
      margin: 0;
    }
  }
}
</style>
